<template>
  <div>
    <el-dialog :title="'指派施工员'" :visible="visible" width="50%" @close="closeDialog" :close-on-click-modal="false"
      append-to-body :z-index="1000">
      <div class="container">
        <el-table :data="allStages" border style="width: 100%" v-if="allStages.length > 0 && !getAllStagesLoading">
          <el-table-column label="阶段" align="center">
            <template slot-scope="scope">
              {{ scope.row.name }}
            </template>
          </el-table-column>
          <el-table-column label="状态" width="120" align="center">
            <template slot-scope="scope">
              <el-tag :type="getStatusType(scope.row.status)">{{ getStatusLabel(scope.row.status) }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="当前施工员" align="center">
            <template slot-scope="scope">
              {{ formatEngineerDisplay(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <div class="operation-buttons">
                <el-button type="text" icon="el-icon-edit" size="small" @click="handleAssignEngineer(scope.row)"
                  :disabled="isAssignDisabled(scope.row)"
                  v-if="permission.JOINS_SALES_CLOUD_WF_ASSIGN_ENGINEER">
                  {{ scope.row.engineerId ? '改派' : '指派' }}
                </el-button>
                <el-button type="text" icon="el-icon-refresh" size="small"
                  v-if="(scope.row.status == 'TO_BE_EVALUATED' || scope.row.status == 'COMPLETE') && permission.JOINS_SALES_CLOUD_WF_REVERSE_REVIEW"
                  @click="handleReverseReview(scope.row)">
                  反审核
                </el-button>
                <el-button type="text" icon="el-icon-delete" size="small" @click="handleDeleteStage(scope.row)"
                  :disabled="isDeleteDisabled(scope.row)"
                  v-if="permission.JOINS_SALES_CLOUD_WF_ADD_STAGE">
                  删除
                </el-button>
                <div v-if="scope.row.errorMessage" class="error-message">
                  {{ scope.row.errorMessage }}
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="add-stage-section" v-if="allStages.length > 0">
          <el-button type="text" size="small" @click="showAddStageDialog"
            v-if="permission.JOINS_SALES_CLOUD_WF_ADD_STAGE">
            <i class="el-icon-plus"></i> 新增阶段
          </el-button>
        </div>
        <div class="empty-state" v-if="allStages.length === 0">
          <div class="empty-placeholder">
            <i class="el-icon-info"></i>
            <p>暂无阶段数据</p>
          </div>
          <el-button type="text" size="small" @click="showAddStageDialog"
            v-if="permission.JOINS_SALES_CLOUD_WF_ADD_STAGE">
            <i class="el-icon-plus"></i> 新增阶段
          </el-button>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog" type="text" size="small" plain icon="el-icon-close">关闭</el-button>
      </span>
      <el-dialog :title="'指派施工员'" :visible="assignDialogVisible" width="40%" @close="assignDialogVisible = false"
        :close-on-click-modal="false" append-to-body :z-index="2000">
        <el-form :model="assignForm" label-width="80px">
          <el-form-item label="阶段：" :error="assignForm.errorMessage">
            <span>{{ currentStage ? currentStage.name : '' }}</span>
          </el-form-item>
          <el-form-item label="施工员：" :error="assignForm.errorMessage">
            <el-select v-model="assignForm.engineerId" placeholder="请输入手机号" filterable remote reserve-keyword
              default-first-option :loading="assignSearchLoading" :remote-method="handleRemoteSearchForAssign"
              :popper-append-to-body="false" clearable>
              <el-option v-for="engineer in assignEngineersList" :key="engineer.userId" :label="engineer.userName"
                :value="engineer.userId">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="assignDialogVisible = false" type="text" size="small" plain
            icon="el-icon-close">取消</el-button>
          <el-button type="text" size="small" plain icon="el-icon-check" @click="confirmAssign"
            :loading="assignLoading" v-if="permission.JOINS_SALES_CLOUD_WF_ASSIGN_ENGINEER">确认指派</el-button>
        </span>
      </el-dialog>
      <el-dialog :title="'新增阶段'" :visible="addStageDialogVisible" width="40%" @close="addStageDialogVisible = false"
        :close-on-click-modal="false" append-to-body :z-index="2000">
        <el-form :model="addStageForm" label-width="80px">
          <el-form-item label="选阶段：" :error="addStageForm.errorMessage">
            <el-select v-model="addStageForm.stageId" placeholder="请选择阶段" :loading="availableStagesLoading"
              :popper-append-to-body="false" style="width: 100%">
              <el-option v-for="stage in availableStages" :key="stage.id" :label="stage.name" :value="stage.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addStageDialogVisible = false" plain type="text" size="small"
            icon="el-icon-close">取消</el-button>
          <el-button type="text" size="small" plain icon="el-icon-check" @click="confirmAddStage"
            :loading="addStageLoading" v-if="permission.JOINS_SALES_CLOUD_WF_ADD_STAGE">确认添加</el-button>
        </span>
      </el-dialog>
      <el-dialog :title="'绑定经营主体'" :visible="businessEntityDialogVisible" width="40%"
        @close="businessEntityDialogVisible = false" :close-on-click-modal="false" append-to-body :z-index="3000">
        <el-form :model="businessEntityForm" label-width="180px">
          <el-form-item label="经营主体：">
            <el-select v-model="businessEntityForm.businessEntityId" placeholder="请选择经营主体" filterable remote
              reserve-keyword default-first-option :loading="businessEntityLoading"
              :remote-method="handleBusinessEntityRemoteSearch" :popper-append-to-body="false" style="width: 100%">
              <el-option v-for="entity in businessEntityList" :key="entity.id" :label="entity.entityName"
                :value="entity.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="businessEntityDialogVisible = false" type="text" size="small" plain
            icon="el-icon-close">取消</el-button>
          <el-button type="text" size="small" plain icon="el-icon-check"
            @click="confirmBusinessEntityBinding">确认绑定</el-button>
        </span>
      </el-dialog>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { findUserList,updateWaterProofStage, getPhaseList, getWaterProofStageInfo, delPhaseWaterProofStage, addPhaseWaterProofStage } from "@/api/work/waterProof/merchants";
import { reverseReviewWaterProof } from "@/api/work/waterProof/merchants";
import { getBusinessEntityList, addShopEntityBind } from '@/api/salesCloud/businessEntity/businessEntity';
import { DIC } from "@/const/dic";
export default {
  name: "assignEngineerStage",
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    stages: {
      type: Array,
      default: () => [],
    },
    orderId: {
      type: [String, Number],
      required: true,
    },
    rootDepartId: {
      type: [String, Number],
      required: true,
    },
    shopId: {
      type: [String, Number, null],
      default: null,
    },
    shopName: {
      type: String,
      required: true,
    },
    contactMobile: {
      type: String,
      required: true,
    },
    customAddress: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      allStages: [], 
      availableStages: [], 
      assignDialogVisible: false, 
      addStageDialogVisible: false, 
      businessEntityDialogVisible: false, 
      currentStage: null, 
      assignForm: {
        engineerId: null,
        errorMessage: '',
      },
      addStageForm: {
        stageId: null,
        errorMessage: '',
      },
      businessEntityForm: {
        businessEntityId: '',
      },
      businessEntityList: [], 
      businessEntityLoading: false, 
      currentShopId: null,
      currentShopName: '',
      currentShopMobile: '',
      currentCustomAddress: '',
      assignEngineersList: [], 
      assignSearchLoading: false, 
      assignLoading: false, 
      availableStagesLoading: false, 
      addStageLoading: false, 
      confirmLoading: false, 
      getAllStagesLoading: false, 
    };
  },
  computed: {
    ...mapGetters(["permission"]),
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.initData();
      }
    },
  },
  methods: {
    async initData() {
      await this.getAllStages();
      this.getAvailableStages();
    },
    async getAllStages() {
      this.getAllStagesLoading = true;
      try {
        const res = await getWaterProofStageInfo(this.orderId);
        if (res.code === "200") {
          const stagesData = JSON.parse(res.data) || [];
          this.allStages = stagesData.map(stage => ({
            ...stage,
            id: stage.goodsId,
            name: stage.goodsName,
            status: stage.orderStatus,
            isShow: String(stage.isShow),
            engineerId: stage.engineerId,
            engineerName: stage.engineerName,
            delivered: stage.delivered,
            submitted: stage.submitted,
            errorMessage: '',
            isNewlyAdded: false,
          }));
        } else if (res.code == "24022061") {
          this.$message.warning(res.message || '报单商家经营主体不存在，请设置经营主体！');
          this.closeDialog();
          this.$emit('bindBusinessEntity');
          return;
        } else {
          this.$message.error(res.message || '获取阶段详情失败');
          this.allStages = [];
        }
      } catch (error) {
        this.$message.error('获取阶段详情失败');
        this.allStages = [];
      } finally {
        this.getAllStagesLoading = false;
      }
    },
    async getAvailableStages() {
      this.availableStagesLoading = true;
      try {
        const res = await getPhaseList(this.rootDepartId);
        if (res.code == "200") {
          const allConfiguredStages = JSON.parse(res.data) || [];
          this.availableStages = this.buildAvailableStages(allConfiguredStages);
        } else {
          this.$message.error(res.message || '获取阶段配置列表失败');
          this.availableStages = this.getMockAvailableStages();
        }
      } catch (error) {
        this.$message.error('获取阶段配置列表失败');
      } finally {
        this.availableStagesLoading = false;
      }
    },
    normalizeStageId(id) {
      return String(id);
    },
    buildAvailableStages(allConfiguredStages = []) {
      const existingStageIds = new Set(this.allStages.map(stage => this.normalizeStageId(stage.id)));
      const seenIds = new Set();
      const uniqueStages = [];
      allConfiguredStages.forEach((stage) => {
        const stageId = this.normalizeStageId(stage.id);
        if (!seenIds.has(stageId) && !existingStageIds.has(stageId)) {
          seenIds.add(stageId);
          uniqueStages.push(stage);
        }
      });
      return uniqueStages;
    },
    handleRemoteSearchForAssign(query) {
      if (!query) {
        this.assignEngineersList = [];
        return;
      }
      /* // 仅在输入8位及以上数字时触发搜索
      if (!/^\d{8,}$/.test(query)) {
        this.assignEngineersList = [];
        return;
      } */
      const params = {
        keyword: query,
      };
      this.assignSearchLoading = true;
      findUserList(params).then((res) => {
        if (res.code == "200") {
          const data = JSON.parse(res.data) || [];
          this.assignEngineersList = data;
        } else {
          this.assignEngineersList = [];
        }
      }).finally(() => {
        this.assignSearchLoading = false;
      });
    },
    handleAssignEngineer(stage) {
      this.currentStage = stage;
      this.assignForm = {
        engineerId: '',
        engineerName: '',
        errorMessage: '',
      };
      this.assignEngineersList = [];
      this.assignDialogVisible = true;
    },
    confirmAssign() {
      if (!this.assignForm.engineerId) {
        this.assignForm.errorMessage = '请选择施工员';
        return;
      }
      this.assignLoading = true;
      const data = {
        projectType: "WATERPROOF_PROJECT",
        declarationId: this.orderId,
        goodsId: this.currentStage.id,
        engineerId: this.assignForm.engineerId,
      };
      updateWaterProofStage(data).then((res) => {
        if (res.code == "200") {
          this.$message.success('指派成功');
          const stageIndex = this.allStages.findIndex(s => s.id === this.currentStage.id);
          if (stageIndex !== -1) {
            const selectedEngineer = this.assignEngineersList.find(e => e.userId === this.assignForm.engineerId);
            this.$set(this.allStages, stageIndex, {
              ...this.allStages[stageIndex],
              engineerId: this.assignForm.engineerId,
              engineerName: selectedEngineer ? selectedEngineer.userName : null,
              engineerPhone: selectedEngineer ? selectedEngineer.userMobile : null,
              status: 'IN_SERVICE',
              errorMessage: '',
            });
          }
          this.assignDialogVisible = false;
          this.$emit('refresh');
        } else if (res.code == "24022061") {
          this.$message.warning(res.message || '报单商家经营主体不存在，请设置经营主体！');
          this.openBusinessEntityDialog(this.shopId, this.shopName, this.contactMobile, this.customAddress);
        } else {
          this.$message.error(res.message || '指派失败');
        }
      }).finally(() => {
        this.assignLoading = false;
      });
    },
    handleReverseReview(stage) {
      this.$confirm('是否确认反审核该阶段?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        reverseReviewWaterProof(stage.orderId).then((res) => {
          if (res.code == '200') {
            this.$message.success('反审核成功');
            this.initData();
            this.$emit('refresh');
          } else {
            this.$message.error(res.message || '反审核失败');
          }
        });
      }).catch(() => {});
    },
    handleDeleteStage(stage) {
      if (this.isDeleteDisabled(stage)) {
        this.$message.warning('当前阶段不可删除');
        return;
      }
      this.$prompt('请输入删除该阶段的原因', '删除阶段', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType: 'textarea',
        inputValidator: (val) => {
          if (!val || !val.trim()) {
            return '删除原因不能为空';
          }
          return true;
        },
      }).then(({ value }) => {
        const reason = value.trim();
        this.$confirm(`确定要删除该阶段的指派吗？\n删除原因：${reason}`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delPhaseWaterProofStage(stage.orderId, reason).then((res) => {
            if (res.code == "200") {
              this.$message.success('删除成功');
              this.initData();
            } else {
              this.$message.error(res.message || '删除失败');
            }
          });
        }).catch(() => {
        });
      }).catch(() => {
      });
    },
    async showAddStageDialog() {
      this.addStageForm = {
        stageId: null,
        errorMessage: '',
      };
      await this.getAvailableStages();
      this.addStageDialogVisible = true;
    },
    confirmAddStage() {
      if (!this.addStageForm.stageId) {
        this.addStageForm.errorMessage = '请选择阶段';
        return;
      }
      this.addStageLoading = true;
      const selectedStage = this.availableStages.find(
        s => this.normalizeStageId(s.id) === this.normalizeStageId(this.addStageForm.stageId)
      );
      if (!selectedStage) {
        this.addStageForm.errorMessage = '阶段数据未准备好，请重试';
        return;
      }
      const data = {
        declarationId: this.orderId,
        goodsId: selectedStage.id,
      };
      addPhaseWaterProofStage(data).then((res) => {
        if (res.code == "200") {
          this.$message.success('新增阶段成功');
          this.initData();
          this.addStageDialogVisible = false;
          this.$emit('refresh');
        } else {
          this.$message.error(res.message || '新增阶段失败');
        }
      }).finally(() => {
        this.addStageLoading = false;
      });
    },
    isSubmittedOrWrittenOff(stage) {
      const isSubmitted = stage.submitted === true;
      const isWrittenOff = stage.delivered === true;
      return isSubmitted || isWrittenOff;
    },
    isAssignDisabled(stage) {
      return this.isSubmittedOrWrittenOff(stage);
    },
    isDeleteDisabled(stage) {
      return this.isSubmittedOrWrittenOff(stage);
    },
    getStatusType(status) {
      const map = {
        'WAIT_FOR_ASSIGN': 'info',       
        'WAIT_ACCEPT': 'info',           
        'IN_SERVICE': 'warning',         
        'TO_BE_CONFIRMED': '',           
        'TO_BE_THE_FINAL': '',           
        'TO_BE_EVALUATED': '',           
        'COMPLETE': 'success',           
        'CANCELLED': 'danger',           
      };
      return map[status] !== undefined ? map[status] : 'info';
    },
    getStatusLabel(status) {
      const statusItem = DIC.PRE_FILTER_STATUS.find(item => item.value === status);
      return statusItem ? statusItem.label : status;
    },
    formatEngineerDisplay(row) {
      const name = row.engineerName || '';
      if (name && /\([\d\-\+\s]+\)/.test(name)) {
        return name;
      }
      return name + ' ' + (row.engineerPhone ? '(' + row.engineerPhone + ')' : '未指派');
    },
    closeDialog() {
      this.$emit('update:visible', false);
    },
    openBusinessEntityDialog(shopId, shopName, shopMobile, customAddress) {
      this.currentShopId = shopId;
      this.currentShopName = shopName;
      this.currentShopMobile = shopMobile;
      this.currentCustomAddress = customAddress;
      this.businessEntityDialogVisible = true;
      this.getBusinessEntityList();
    },
    getBusinessEntityList(entityName = '') {
      this.businessEntityLoading = true;
      const params = {
        page: '1',
        size: '100', 
        entityName: entityName
      };
      getBusinessEntityList(params)
        .then(res => {
          const data = JSON.parse(res.data);
          this.businessEntityList = data.rows || [];
        })
        .finally(() => {
          this.businessEntityLoading = false;
        });
    },
    handleBusinessEntityRemoteSearch(query) {
      this.getBusinessEntityList(query);
    },
    confirmBusinessEntityBinding() {
      if (!this.businessEntityForm.businessEntityId) {
        this.$message.error('请选择要绑定的经营主体');
        return;
      }
      if (!this.currentShopId) {
        this.$message.error('商户信息有误，请重试');
        return;
      }
      const params = [{
        shopId: this.currentShopId,
        businessEntityId: this.businessEntityForm.businessEntityId,
        shopName: this.currentShopName,
        shopMobile: this.currentShopMobile
      }];
      addShopEntityBind(params)
        .then(res => {
          if (res.code == '200') {
            this.$message.success('绑定经营主体成功');
            this.businessEntityDialogVisible = false;
            this.businessEntityForm.businessEntityId = '';
            this.currentShopId = null;
            this.currentShopName = '';
            this.currentCustomAddress = '';
            this.currentShopMobile = '';
          } else {
            this.$message.error(res.message || '绑定经营主体失败');
          }
        });
    },
  },
};
</script>
<style scoped>
.container {
  max-height: 600px;
  overflow-y: auto;
  padding-right: 10px;
}
.empty-state {
  padding: 40px 0;
  text-align: center;
}
.empty-state .empty-placeholder {
  color: #909399;
}
.empty-state .empty-placeholder i {
  font-size: 64px;
  display: block;
  margin-bottom: 16px;
}
.empty-state .empty-placeholder p {
  margin: 0;
  font-size: 14px;
}
.empty-state .el-button {
  margin-top: 20px;
}
.dialog-footer {
  text-align: right;
}
.container::-webkit-scrollbar {
  width: 8px;
}
.container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}
.container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}
.container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
.el-table {
  margin-bottom: 20px;
}
.el-table th {
  background-color: #f5f7fa;
  font-weight: bold;
}
.operation-buttons {
  display: flex;
  justify-content: center;
  gap: 8px;
}
.operation-buttons .el-button {
  padding: 4px 12px;
}
.add-stage-section {
  margin-top: 20px;
  text-align: right;
}
.el-form-item__error {
  position: absolute;
  top: 100%;
  left: 0;
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
}
.error-message {
  color: #f56c6c;
  font-size: 12px;
  margin-top: 4px;
}
</style>